import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { createStructuredSelector } from 'reselect';
import { selectShowPoweredBy } from '../../selectors';
import PoweredBy from '../PoweredBy/PoweredBy';

import './Footer.scss';

export const Footer = ({ showPoweredBy, footerClassName = '', children }) => {
  const cls = cx('bg-window', 'flex', 'items-center', 'foot', {
    [footerClassName]: footerClassName,
    'justify-end': !showPoweredBy,
    'justify-between': showPoweredBy,
  });

  return (
    <footer className={cls}>
      {showPoweredBy && <PoweredBy />}
      {children}
    </footer>
  );
};

export default connect(
  createStructuredSelector({
    showPoweredBy: selectShowPoweredBy,
  })
)(Footer);
